import isEqual from 'lodash/isEqual';
import set from 'lodash/set';
import type { Field } from '@atlassian/jira-polaris-domain-field/src/field/types.tsx';
import type { LocalIssueId } from '@atlassian/jira-polaris-domain-idea/src/idea/types.tsx';
import type { IssuesRemote } from '@atlassian/jira-polaris-remote-issue/src/controllers/types.tsx';
import {
	jiraExternalReferenceMapping,
	type Value,
} from '../../../../field/mapping/external-reference/index.tsx';
import type { PropertyMaps } from '../../../types.tsx';
import type { FieldMapping } from '../types.tsx';

export const goalsMapping = (issuesRemote: IssuesRemote, field: Field): FieldMapping<Value> => {
	const valueAccessor: FieldMapping<string | string[]>['valueAccessor'] = (
		state,
		props,
		issueId,
	) =>
		state.properties?.goals[field.key] !== undefined
			? state.properties.goals[field.key][issueId]
			: undefined;
	return {
		...jiraExternalReferenceMapping(issuesRemote, field),
		setMutable: (maps: PropertyMaps, issueId: LocalIssueId, value?: Value) =>
			set(maps.goals, [field.key, issueId], value),
		setImmutable: (maps: PropertyMaps, issueId: LocalIssueId, value?: Value) => {
			if (maps.goals[field.key] && isEqual(maps.goals[field.key][issueId], value)) {
				return maps;
			}
			return {
				...maps,
				goals: {
					...maps.goals,
					[field.key]: {
						...maps.goals[field.key],
						[issueId]: value,
					},
				},
			};
		},
		remove: (propertyMaps) => propertyMaps,
		modifyImmutableIfMultiValueField: (propertyMaps) => propertyMaps,
		comparator: () => 0,
		valueAccessor,
		valueAccessorToExport: () => '',
		getAllValues: (state) =>
			state.properties.goals[field.key] ? state.properties.goals[field.key] : {},
		getGroupIdentitiesSelector: (_fieldKey, _issueIdsSelector) => () => ({}),
		getGroupIdentities: () => [],
		isMultiValueField: false,
		isSupportedByIssueUpdateApi: false,
		allowEmptyGroup: true,
		getLabel: (groupIdentity, value) => {
			if (Array.isArray(value)) {
				return value[0] || groupIdentity;
			}
			return value || groupIdentity;
		},
		getFilter: () => undefined,
	};
};
